import styled from 'styled-components';

const AdminFilterBar = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 0.75rem;
    align-items: center;
    justify-content: space-between;
    background: ${({ theme }) => theme.colors.surfaceAlt || '#f9fafb'};
    border: 1px solid ${({ theme }) => theme.colors.border || '#e5e7eb'};
    border-radius: 12px;
    padding: 0.75rem;
    margin-bottom: 1rem;
`;

export default AdminFilterBar;

